import { api } from "./api";

export class VehicleManufacturerService {
  async post(value: string) {
    try {
      const response = await api.post(`/vehicle-manufacturer`, value);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }

  async get() {
    try {
      const response = await api.get(`/vehicle-manufacturer`);
      return response.data.data;
    } catch (error: any) {
      return error.response;
    }
  }

  async getById(id: string) {
    try {
      const response = await api.get(`/vehicle-manufacturer/${id}`);
      return response.data.data;
    } catch (error: any) {
      return error.response;
    }
  }

  async patch(value: string, id: string) {
    try {
      const response = await api.patch(`/vehicle-manufacturer/${id}`, value);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }

  async delete(id: string) {
    try {
      const response = await api.delete(`/vehicle-manufacturer/${id}`);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }
}
